import LightBulbFilled from './src/light-bulb-filled';
export default LightBulbFilled;